if (!customElements.get('size-guide')) {
  class SizeGuide extends HTMLElement {
    constructor() {
      super();

      this.tableContainer = document.getElementById('Size-Guide-Table-Container');
      this.table = document.createElement('table');
      this.rawTableData = this.dataset.sizeGuideInfo.toString();
      this.jsonData = [];
    }

    connectedCallback() {
      this.metafieldToJSON(this.rawTableData);
    }

    metafieldToJSON(metafieldData) {
      const headers = [];
      const rows = metafieldData.split('/');
      for (let i = 0; i < rows.length; i++) {
        const cells = rows[i].split(';');
        const rowData = {};
        for (let j = 0; j < cells.length; j++) {
          if (i === 0) {
            const headerName = cells[j].trim();
            headers.push(headerName);
          } else {
            const key = headers[j];
            if (key) {
              // See [PR189](https://github.com/underscore-district/magliano-website/pull/189)
              // for info about this line
              rowData[` ${key}`] = cells[j].trim();
            }
          }
        }
        if (i !== 0) {
          this.jsonData.push(rowData);
        }
      }
      this.createTable();
    }

    addTableHead(keys) {
      this.table.createTHead();
      const row = this.table.querySelector('thead').insertRow();
      keys.forEach((key) => {
        const cell = row.appendChild(document.createElement('th'));
        cell.appendChild(document.createTextNode(key));
      });
    }

    createTable() {
      this.tableContainer.innerHTML = '';
      this.jsonData.forEach((data, index) => {
        // handle the head of the table
        if (index === 0) {
          this.addTableHead(Object.keys(data));
          this.table.createTBody();
        }
        // handle the body of the table
        const row = this.table.querySelector('tbody').insertRow();
        Object.keys(data).forEach((i) => {
          const cell = row.insertCell();
          cell.appendChild(document.createTextNode(data[i]));
        });
      });
      this.tableContainer.appendChild(this.table);
    }
  }

  customElements.define('size-guide', SizeGuide);
}
